import { Box, Drawer, Grid, List } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledSidebarDrawer = styled(Drawer)(({ theme }) => ({
  flexShrink: 1,
  "& .MuiDrawer-paper": {
    backgroundColor: (theme.palette as any).foreground?.inverted,
    width: "450px",
    paddingBottom: "50px",
    marginTop: "54px",
    zIndex: 1100,
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%"
    }
  }
}))

export const StyledListWrapper = styled(List)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  padding: 0
})

interface StyledListItemHeaderGridProps {
  flexDirection?: "row" | "column" | "row-reverse" | "column-reverse"
  alignItems?: "center" | "flex-start" | "flex-end" | "baseline" | "stretch"
}

export const StyledListItemHeaderGrid = styled(Grid)<StyledListItemHeaderGridProps>(({ theme, flexDirection, alignItems }) => ({
  display: "flex",
  flexDirection: flexDirection || "row",
  borderBottom: "1px solid",
  borderColor: theme.palette.divider,
  alignItems: alignItems || "center"
}))

export const StyledStickyButtonBox = styled(Box)(({ theme }) => ({
  marginTop: "auto",
  width: "100%",
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  position: "sticky",
  bottom: 0,
  left: 0,
  backgroundColor: theme.palette.background.paper,
  borderTop: "1px solid",
  borderColor: theme.palette.divider,
}))

export const StyledChildrenWrapper = styled(Box)({
  display: "flex",
  height: "auto",
  flexDirection: "column",
})
